<template>
  <ftw-serverside-collection
    ref="collection"
    :fetch="fetchSystemMessages"
    page-size-param="page_size"
    :filter.sync="filter"
    :headers="tableHeaders"
    v-bind="$attrs"
    item-key="id"
    route-replace
  >
    <template #item.type="{ item }">
      {{ item.type.name }}
    </template>
    <template #item.begin="{ item }">
      {{ toLocaleDateTimeString(item.begin) }}
    </template>
    <template #item.end="{ item }">
      {{ toLocaleDateTimeString(item.end) }}
    </template>
    <template #item.text="{ item }">
      <div v-if="item.text" class="truncate">{{ item.text }}</div>
    </template>
    <template #item.text_color="{ item }">
      <v-icon class="mr-2" :color="item.text_color"> mdi-square-rounded </v-icon>
    </template>
    <template #item.background_color="{ item }">
      <v-icon class="mr-2" :color="item.background_color"> mdi-square-rounded </v-icon>
    </template>
    <template #item.menu="{ item }">
      <div>
        <SystemMessageModal :item="item" :types="types" @success="refresh">
          <template #activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
        </SystemMessageModal>
        <DeleteConfirmationModal
          :object="item"
          :on-delete="deleteSystemMessage"
          :error-message="$t('systemMessage.deleteError')"
        >
          <template #activator="{ on, attrs }">
            <v-btn :data-testid="`remove-template-button-${item.id}`" icon v-bind="attrs" v-on="on">
              <v-icon color="red">mdi-delete</v-icon>
            </v-btn>
          </template>
        </DeleteConfirmationModal>
      </div>
    </template>
  </ftw-serverside-collection>
</template>

<script>
import { join } from 'path'
import { api } from '@/api'
import { createLink } from '@/api/helpers'
import castArray from 'lodash/castArray'
import { fromQueryString } from '@4tw/ui/lib/util/query'
import { toLocaleDateTimeString } from '@/filters'

export default {
  name: 'SystemMessageTable',
  props: {
    types: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      filter: fromQueryString(
        this.$route.query,
        ['ordering'],
        {
          ordering: [],
        },
        {
          ordering: castArray,
        },
      ),
      tableHeaders: [
        {
          text: this.$t('systemMessage.title'),
          value: 'title',
          sortable: true,
        },
        {
          text: this.$t('systemMessage.type'),
          value: 'type',
          sortable: true,
        },
        {
          text: this.$t('systemMessage.begin'),
          value: 'begin',
          sortable: true,
        },
        {
          text: this.$t('systemMessage.end'),
          value: 'end',
          sortable: true,
        },
        {
          text: this.$t('systemMessage.text'),
          value: 'text',
          sortable: true,
        },
        {
          text: this.$t('systemMessage.textColor'),
          value: 'text_color',
        },
        {
          text: this.$t('systemMessage.backgroundColor'),
          value: 'background_color',
        },
        {
          value: 'menu',
        },
      ],
    }
  },
  methods: {
    toLocaleDateTimeString,
    async fetchSystemMessages(params) {
      const { data } = await api.get(createLink('system_message'), { params })
      return data
    },
    async deleteSystemMessage(info) {
      try {
        await api.delete(createLink(join('system_message', info.id.toString())))
      } catch (e) {
        this.notifyError(this.$t('systemMessage.dismissError'))
        return
      }
      this.refresh()
    },
    refresh() {
      this.$refs.collection.update()
    },
  },
}
</script>
